import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('start-3761_journey-builder-parent-conditions');
	},
};
